/**
 * Resolve the chat, then upload into it.
 *
 * The chat is resolved *inside* the tracked promise so the registry entry exists
 * before the request does — removing an attachment must be able to cancel an
 * upload that has not started yet, and the idempotency key is what addresses it
 * server-side either way.
 */
export function startAttachmentUpload({
  attachment,
  chat,
  uploads,
  onState,
  run,
  idempotencyKey,
  onUploaded,
}) {
  const controller = new AbortController()
  const entry = { controller, idempotencyKey, chatId: null }
  let chatId = null

  const promise = chat
    .resolve(attachment.file?.name)
    .then((resolved) => {
      chatId = resolved?.id ?? null
      // A cancelled chip must not be re-registered after its provisional chat resolves.
      if (!uploads.bindChat(attachment.id, chatId))
        throw new Error('Attachment was cancelled')
      return run({
        file: attachment.file,
        chatId,
        projectId: resolved?.projectId ?? null,
        idempotencyKey,
        signal: controller.signal,
        onState,
      })
    })
    .then((documentId) => {
      uploads.settle(attachment.id, documentId)
      onUploaded(chatId)
      return { id: attachment.id, documentId }
    })
    // Aborted: the attachment is already gone from the composer and `cancel`
    // has taken care of the server side.
    .catch(() => ({ id: attachment.id, documentId: null }))

  return uploads.track(attachment.id, { ...entry, promise })
}
